export default __webpack_public_path__ + "static/medical_gas_b.e74fdfd187f539fb5dc3c9c8c171ff12.svg";